import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { createAsyncState } from 'async-utils';
import { Nullable } from 'common-types';
import { Dayjs } from 'dayjs';
import { createStore, derive } from 'store-utils';
import { AuditLogFilters, Direction, OrderBy } from '../types/audit-logs-types';

export const initialAuditLogsStore: Partial<AuditLogsStoreState> = {
  offset: 0,
  total: 0,
  orderBy: {
    direction: Direction.DESC,
    field: 'date',
  },
  auditLogs: [],
  loading: createAsyncState(),
  errorMessage: null,
  selectedAuditLogId: null,
  selectedAuditLog: null,
  lastDrawerHeight: undefined,
  filtersOpen: true,
  loadingFilters: createAsyncState(),
  totalFiltered: 0,
  filterBy: {},
  searchValues: {},
  filtersTypeSearch: null,
  filters: null,
  datePickerFrom: null,
  datePickerTo: null,
};

const baseStore = createStore<AuditLogsStoreState>(
  {
    ...JSON.parse(JSON.stringify(initialAuditLogsStore)),
    loading: createAsyncState(),
    loadingFilters: createAsyncState(),
  },

  'Audit Logs Store',
);

const AuditLogsStore = derive(
  {
    numberOfFilters: get => {
      const { filterBy: filterArtifactsBy } = get(baseStore);
      return (
        Object.keys(filterArtifactsBy).reduce(
          (acc, key) => acc + filterArtifactsBy[key].length,
          0,
        ) || 0
      );
    },
  },
  { proxy: baseStore },
);

interface AuditLogsStoreState {
  auditLogs: AuditLog[];
  loading: ReturnType<typeof createAsyncState>;
  offset: number;
  total: number;
  orderBy: OrderBy;
  errorMessage: Nullable<string>;
  selectedAuditLogId: Nullable<string>;
  selectedAuditLog: Nullable<AuditLog>;
  lastDrawerHeight?: number;
  filtersOpen: boolean;
  loadingFilters: ReturnType<typeof createAsyncState>;
  totalFiltered: number;
  filterBy: {};
  searchValues: {};
  filtersTypeSearch: Nullable<AuditLogFilters>;
  filters: Nullable<AuditLogFilters>;
  datePickerFrom: Nullable<Dayjs>;
  datePickerTo: Nullable<Dayjs>;
}

export default AuditLogsStore;
